// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"b841f634","aiSupportButton":"a54cd6f6","appearButton":"ccb3f3e9"};